import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  getFormValues,
  change,
  getFormSyncErrors,
  getFormInitialValues,
} from 'redux-form';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { diff } from 'deep-diff';

import { getGradesAction } from 'State/grades/actions';
import { getCaseTypes } from 'State/caseTypes/actions';
import { Filter, Main } from 'Containers';
import { LoadingPage } from 'Components';
import { APPLICATION_STUDENT_FORM_NAME } from 'Common/FormEnum';
import { defaultDateFormat, submitDelay } from 'Common/GeneralHelper';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { LanguageEnum } from 'Common/Constants/Enumeration/LanguageEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { addToQueryString } from 'Common/Helpers/querystring';
import { addStudentToApp } from '../state/studentlookup/actions';
import StudentForm from '../components/student/StudentForm';
import { updateStudent, deleteStudent } from '../state/hub/actions';
import { NEW_STUDENT, MODIFY_BUTTON_TEXT } from '../helpers/Constants';

class Student extends Component {
  static path = '/manageapplication/:familyId/student/:studentNumber';

  state = {
    isReady: false,
  };

  componentDidMount() {
    if (!this.props.students) {
      this.props.history.replace(this.getRootUrl());
    } else {
      this.props.getGradesAction();
      this.props.getCaseTypes();
    }
  }

  componentWillReceiveProps(newProps) {
    if (diff(newProps.formValues, this.props.formValues) !== undefined) {
      this.props.setPageLevelDirty(true);
    }
  }

  componentDidUpdate(prevProps) {
    const { formValues, change } = this.props;

    if (this.props.grades && this.props.caseTypes && !this.state.isReady) {
      this.setState({ isReady: true });
    }

    //set initally selected language on change to Emancipated
    if (
      _.has(formValues, `Exceptions.${Fields.IsEmancipatedMinor}`) &&
      _.has(prevProps.formValues, `Exceptions.${Fields.IsEmancipatedMinor}`) &&
      formValues.Exceptions[Fields.IsEmancipatedMinor] &&
      !prevProps.formValues.Exceptions[Fields.IsEmancipatedMinor]
    ) {
      change(
        APPLICATION_STUDENT_FORM_NAME,
        Fields.LanguageId,
        LanguageEnum.English
      );
    }
  }

  isNewStudent = () => {
    const { initialValues = {} } = this.props;
    const idSeed = initialValues[Fields.IdSeed] || 0;

    return idSeed === NEW_STUDENT[Fields.IdSeed];
  };

  getRootUrl = () => {
    const { isSecondReview, isVerification, history } = this.props;
    const currentQueryString = _.get(history, 'location.search', '');
    const queryString = addToQueryString(currentQueryString, {
      secondReview: 0,
      verification: 0,
    });
    if (isSecondReview) {
      const queryString = addToQueryString(currentQueryString, {
        secondReview: 1,
        verification: 0,
      });
      return `${this.props.match.url.replace(
        /\/student\/.*/gi,
        ''
      )}${queryString}`;
    }
    if (isVerification) {
      const queryString = addToQueryString(currentQueryString, {
        secondReview: 0,
        verification: 1,
      });
      return `${this.props.match.url.replace(
        /\/student\/.*/gi,
        ''
      )}${queryString}`;
    }
    return `${this.props.match.url.replace(
      /\/student\/.*/gi,
      ''
    )}${queryString}`;
  };

  getStudent = () => {
    if (this.props.students) {
      const student = this.props.students.find(
        (x) => x.Id === this.props.match.params.studentNumber
      );

      if (!student) {
        return {};
      }

      const hoh = this.props.members.find((x) => x.IsHOH === true);
      const populateWithHOHLanuageSSN =
        hoh && student.Exceptions.IsEmancipatedMinor;
      const extraProps = {
        BirthDate: student.BirthDate
          ? defaultDateFormat(student.BirthDate)
          : null,
      };
      if (populateWithHOHLanuageSSN) {
        extraProps.LanguageId = hoh.LanguageId;
        extraProps.SSN = hoh.SSN;
      }
      let id = student.Id;

      if (
        !_.isNil(student.Id) &&
        this.isNewStudent() &&
        id === NEW_STUDENT.Id
      ) {
        id = '';
      }

      return {
        ...student,
        Id: id,
        EthnicityId: this.isNewStudent() ? '' : student.EthnicityId,
        RaceId: this.isNewStudent() ? '' : student.RaceId,
        ...extraProps,
      };
    }
  };

  saveStudent = (values) => {
    const { initialValues = {} } = this.props;
    const previousId = initialValues[Fields.Id];

    return submitDelay().then(() => {
      this.props.updateStudent(values, this.isNewStudent(), previousId);
      this.props.history.push(this.getRootUrl());
    });
  };

  onToolboxBackClick = () => {
    if (this.isNewStudent()) {
      //remove the new student
      this.props.deleteStudent(NEW_STUDENT[Fields.Id]);
    }
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      width: {
        largeScreen: 12,
        widescreen: 9,
        tablet: 16,
      },
      toolbox: {
        isReadOnly,
        backButtonProps: {
          shown: true,
          path: this.getRootUrl(),
          callback: this.onToolboxBackClick,
        },
        formName: APPLICATION_STUDENT_FORM_NAME,
        saveButtonProps: {
          content: MODIFY_BUTTON_TEXT,
        },
        shown: true,
      },
    };
  };

  render() {
    if (!this.state.isReady) {
      return <LoadingPage />;
    }

    const { caseTypes, formValues, errors } = this.props;
    return (
      <Fragment>
        <Filter title="Student" />
        <Main {...this.getMainProps()}>
          <StudentForm
            caseTypes={caseTypes}
            errors={errors}
            formValues={formValues || {}}
            gradesLookup={this.props.grades}
            initialValues={this.getStudent()}
            isNewStudent={this.isNewStudent()}
            onSubmit={this.saveStudent}
            isIncomplete={this.props.isIncomplete}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { hub } = state.ManageApplicationState;
  const { grades, caseTypes } = state.CommonState;

  ownProps.setPageLevelDirty(getIsDirty(APPLICATION_STUDENT_FORM_NAME)(state));

  return {
    students: hub.tempApplication.Students,
    members: hub.tempApplication.Members,
    isIncomplete: hub.tempApplication.ApplicationInformation
      ? hub.tempApplication.ApplicationInformation.IsIncomplete
      : null,
    grades: grades.data,
    caseTypes: caseTypes.data,
    formValues: getFormValues(APPLICATION_STUDENT_FORM_NAME)(state),
    errors: getFormSyncErrors(APPLICATION_STUDENT_FORM_NAME)(state),
    isSecondReview: hub.isSecondReview,
    isVerification: hub.isVerification,
    initialValues: getFormInitialValues(APPLICATION_STUDENT_FORM_NAME)(state),
  };
};

Student = withRouter(
  connect(mapStateToProps, {
    getGradesAction,
    getCaseTypes,
    updateStudent,
    change,
    addStudentToApp,
    deleteStudent,
  })(Student)
);

export { Student };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/subpages/Student.js